import React from 'react';
import Template from './Template';

export default (props) => (
  <Template
    {...props}
    src="/Christopher.png"
    name="Christopher Koh "
    position="Chairman, Supervisory Board"
    description={(
      <div>
        <p>
          Christopher is the Chairman of Premium Capital Partners' Supervisory Board, offering key
          business and investment guidance informed by his extensive experience as a senior lawyer
          operating in the field of corporate, commercial and financial affairs. Christopher will
          take lead on internal oversight and governance for Premium Capital Partners, ensuring
          flawless regulatory compliance within an exceptional investment framework.
        </p>
        <p>
          Alongside significant experience working with small and medium enterprises within
          Malaysia, Christopher has undertaken leading advisory roles for international legal firms
          seeking foreign investments, as well as holding an investment advisory position on an
          ASEAN-focussed institutional investment fund. He also has experience setting up and
          building banks and financial institutions for the domestic Malaysian market. Christopher
          also holds positions as Independent Non-Executive Director and Audit Committee Member for
          a number of other companies, including two Bursa-listed organisations.
        </p>
      </div>
    )}
    quote="The beauty of a great business is when you look at it and say 'why weren't we doing this before?'. We're offering powerful but simple financial solutions to business, and I'm proud to be a part of that."
  />
)


// WEBPACK FOOTER //
// ./src/screens/OurTeam/Christopher.js